import React from 'react';
import { UserModel } from '../../../mobx/models/user';
import DropdownItem from '../../dropdown/dropdownItem';
import { AssignBottom, BlankDiv } from './styles';
import { observer } from 'mobx-react-lite';

interface AssigneeDropdownContentProps {
  data: UserModel[];
  currentIndex?: number;
  isMultiAssignee: boolean;
  showUnassignedCheckbox: boolean;
  isUnassignedChecked: boolean;
  isUserAssigned: (userId: string) => boolean;
  onClickUnassignUser: () => void | Promise<void>;
  onClickAssignUser: (user: UserModel) => void;
}

const AssigneeDropdownContent: React.FC<AssigneeDropdownContentProps> = ({
  data,
  currentIndex,
  isMultiAssignee,
  showUnassignedCheckbox,
  isUnassignedChecked,
  isUserAssigned,
  onClickUnassignUser,
  onClickAssignUser
}) => {
  return (
    <AssignBottom>
      <DropdownItem
        label={'Unassigned'}
        onClick={onClickUnassignUser}
        iconName={'unassign-profile-icon'}
        isCheckBox={showUnassignedCheckbox}
        isChecked={isUnassignedChecked}
        iconSize={20}
        iconViewBox='0 0 18 18'>
        {isMultiAssignee && !showUnassignedCheckbox && <BlankDiv />}
      </DropdownItem>
      {data?.map((item, index: number) => {
        const isAssigned = isUserAssigned(item.id);
        return (
          <DropdownItem
            key={index}
            label={item?.name}
            onClick={() => onClickAssignUser(item)}
            isCheckBox={isMultiAssignee}
            isAvatar={true}
            avatarSrc={item?.profile_photo}
            isChecked={isAssigned}
            isActive={currentIndex === index}
            isSelected={isAssigned}
          />
        );
      })}
    </AssignBottom>
  );
};

export default observer(AssigneeDropdownContent);
